import { render } from "./LoansUser.vue?vue&type=template&id=2731cc7b"
import script from "./LoansUser.vue?vue&type=script&lang=js"
export * from "./LoansUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__